import tw from "twin.macro";
import { styled } from "~/config/stitches";

export const AvatarWrapper = styled("span", {
  ...tw`inline-flex mr-1.5`,
});
